/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".text-wrapper[_ngcontent-%COMP%]{float:left;white-space:normal;width:calc(100% - 55px);text-align:left}.drop-list[_ngcontent-%COMP%]{width:500px;max-width:100%;min-height:60px;display:block;background:#fff;border-radius:4px;overflow:hidden}.drop-box[_ngcontent-%COMP%]{padding:10px 0 0;color:rgba(0,0,0,.87);display:flex;flex-direction:row;align-items:left;justify-content:space-between;box-sizing:border-box;cursor:move;font-size:14px}"];
export { styles as styles };
